import React, { Component } from "react";
import Row from "../../../../common/grid/Row";
import MdEdit from "react-icons/lib/md/edit";
import MdDelete from "react-icons/lib/md/delete";
import MdFileDownload from "react-icons/lib/md/file-download";
import { connect } from "react-redux";
import {
	fetchDocuments,
	deleteDocument
} from "../../../../actions/gfa-documents";
import { fetchFolders, deleteFolder } from "../../../../actions/folder";
import RenderIfUserHas from "../../../../common/roles/RenderIfUserHas.js";
import BrowserHistory from "../../../../providers/BrowserHistory.js";
import Button from "../../../../common/button/Button.js";
import Modal from "../../../../common/modal/Modal.js";
import Accordion from "../../../../common/accordion/Accordion.js";
import FaFileO from "react-icons/lib/fa/file-o";
import FaFolderO from "react-icons/lib/fa/folder-o";

import "./GfaDocumentsIndex.css";

class GfaDocumentsIndex extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			confirmed: false,
			folderId: null,
			documentId: null
		};

		this.onAddNewFileBoxClick = this.onAddNewFileBoxClick.bind(this);
		this.onAddNewFolderBoxClick = this.onAddNewFolderBoxClick.bind(this);
		this.onDeleteDocumentClick = this.onDeleteDocumentClick.bind(this);
		this.onDeleteDocumentConfirm = this.onDeleteDocumentConfirm.bind(this);
		this.onDeleteFolderClick = this.onDeleteFolderClick.bind(this);
		this.onDeleteFolderConfirm = this.onDeleteFolderConfirm.bind(this);
	}

	/**
	 * Click handler for add new file box
	 */
	onAddNewFileBoxClick() {
		BrowserHistory.push("/main/gfa-documents/add");
	}

	/**
	 * Click handler for add new folder box
	 */
	onAddNewFolderBoxClick() {
		BrowserHistory.push("/main/folders/add");
	}

	/**
	 * Click handler for delete document button
	 * @param {number} documentId
	 * @param {object} e
	 */
	onDeleteDocumentClick(documentId, e) {
		e.stopPropagation();
		this.setState({ showModal: true, documentId });
	}

	/**
	 * Click handler for confirm document delete button
	 */
	onDeleteDocumentConfirm() {
		this.props.deleteDocument(this.state.documentId);
		this.setState({ showModal: false, confirm: true, documentId: null });
	}

	/**
	 * Click handler for delete folder button
	 * @param {number} folderId
	 * @param {object} e
	 */
	onDeleteFolderClick(folderId, e) {
		e.stopPropagation();
		this.setState({ showModal: true, folderId });
	}

	/**
	 * Click handler for confirm folder delete button
	 */
	onDeleteFolderConfirm() {
		this.props.deleteFolder(this.state.folderId);
		this.setState({ showModal: false, confirm: true, folderId: null });
	}

	/**
	 * Click handler for edit document button
	 * @param {number} documentId
	 * @param {object} e
	 */
	onEditDocumentClick(documentId, e) {
		e.stopPropagation();
		BrowserHistory.push(`/main/gfa-documents/${documentId}/edit`);
	}

	/**
	 * Click handler for edit folder button
	 * @param {number} folderId
	 * @param {object} e
	 */
	onEditFolderClick(folderId, e) {
		e.stopPropagation();
		BrowserHistory.push(`/main/folders/${folderId}/edit`);
	}

	componentDidMount() {
		// this.props.fetchDocuments();
		this.props.fetchFolders();
	}

	render() {
		// if (!this.props.documents || !this.props.folders) {
		//   return null;
		// }
		const showDeleteDocumentModal = !!(
			this.state.showModal && this.state.documentId
		);
		const showDeleteFolderModal = !!(
			this.state.showModal && this.state.folderId
		);

		return (
			<div className="gfa-documents-index">
				<Row _no-grow-last _wrap title>
					<h2>Manage GFA Documents</h2>
					<RenderIfUserHas roles={["admin"]}>
						<Row _gap-8>
							<Button
								className="btn-stretch btn-green"
								onClick={this.onAddNewFileBoxClick}
							>
								<FaFileO size={14} />
								Add Document
							</Button>
							<Button
								className="btn-stretch btn-green"
								onClick={this.onAddNewFolderBoxClick}
							>
								<FaFolderO size={17} />
								Add Folder
							</Button>
							{/* <div className="addNewBox" onClick={this.onAddNewFileBoxClick}>
								<span className="plus">+</span>
								<h2>Add Document</h2>
							</div> */}

							{/* <div className="addNewBox" onClick={this.onAddNewFolderBoxClick}>
								<span className="plus">+</span>
								<h2>Add Folder</h2>
							</div> */}
						</Row>
					</RenderIfUserHas>
				</Row>
				{showDeleteDocumentModal && (
					<Modal
						type="CONFIRMATION"
						onConfirm={this.onDeleteDocumentConfirm}
						onCancel={() =>
							this.setState({
								confirm: false,
								showModal: false,
								documentId: null
							})
						}
						show={this.state.showModal}
					>
						Are you sure you want to delete this document?
					</Modal>
				)}
				{showDeleteFolderModal && (
					<Modal
						type="CONFIRMATION"
						onConfirm={this.onDeleteFolderConfirm}
						onCancel={() =>
							this.setState({
								confirm: false,
								showModal: false,
								folderId: null
							})
						}
						show={this.state.showModal}
					>
						Are you sure you want to delete this folder?
					</Modal>
				)}
				<Accordion>
					{this.props.folders.map(folder => (
						<div key={folder.id} className="" title={folder.name}>
							<div className="folder-info">
								<div className="buttons">
									<RenderIfUserHas roles={["admin"]}>
										<Button
											className=" btn-stretch"
											onClick={this.onEditFolderClick.bind(this, folder.id)}
										>
											<MdEdit size={18} /> <span>Edit Folder</span>
										</Button>
										<Button
											className=" btn-stretch"
											onClick={this.onDeleteFolderClick.bind(this, folder.id)}
										>
											<MdDelete size={18} /> <span>Delete Folder</span>
										</Button>
									</RenderIfUserHas>
								</div>
								<span className="created_at">
									<span className="light">Folder creation date:</span>{" "}
									{folder.created_at}
								</span>
							</div>
							<div className="file-list">
								{folder.documents.map((file, i) => {
									return (
										<div
											className="box"
											key={i}
											onClick={this.onEditDocumentClick.bind(this, file.id)}
										>
											<h2 className="name">{file.name}</h2>
											<span className="created_at">
												<span className="light">Created at:</span>
												<span>{file.created_at}</span>
											</span>
											<div className="buttons">
												<a
													className="btn-blue download-btn"
													href={file.file_url}
												>
													<MdFileDownload size={18} />
												</a>
												<RenderIfUserHas roles={["admin"]}>
													<Button
														className="btn-blue"
														onClick={this.onEditDocumentClick.bind(
															this,
															file.id
														)}
													>
														<MdEdit size={18} />
													</Button>
													<Button
														className="btn-red"
														onClick={this.onDeleteDocumentClick.bind(
															this,
															file.id
														)}
													>
														<MdDelete size={18} />
													</Button>
												</RenderIfUserHas>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					))}
				</Accordion>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		// documents: state.gfaDocument.all,
		folders: state.folder.all
	};
};

const mapDispatchToProps = {
	fetchFolders,
	fetchDocuments,
	deleteDocument,
	deleteFolder
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(GfaDocumentsIndex);



// WEBPACK FOOTER //
// ./src/components/main/gfa-documents/index/GfaDocumentsIndex.js